import Vue from 'vue'
import Router from 'vue-router'


// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
const SimpleContainer = () => import('@/containers/SimpleContainer')

const Dashboard = () => import('@/views/Dashboard')
const Login = () => import('@/views/auth/Login')
const Register = () => import('@/views/auth/Register')
const Profile = () => import('@/views/Profile')
const Calendar = () => import('@/views/Calendar')
const Clients = () => import('@/views/nutritionist/Clients')
const Menus = () => import('@/views/nutritionist/Menus')
const CreateMenu = () => import('@/views/nutritionist/CreateMenu')
const AddClient = () => import('@/views/nutritionist/AddClient')
const SingleClient = () => import('@/views/nutritionist/SingleClient')
const SingleMenu = () => import('@/views/nutritionist/SingleMenu')
const UpdateMenu = () => import('@/views/nutritionist/UpdateMenu')

const Bmi = () => import('@/views/Bmi')
const Specialists = () => import('@/views/Specialists')
const Shop = () => import('@/views/Shop')
const Sales = () => import('@/views/Sales')
const Help = () => import('@/views/Help')
const About = () => import('@/views/About')
const HowTo = () => import('@/views/HowTo')
const Nutritionist = () => import('@/views/Nutritionist')
const SharedMenu = () => import('@/views/SharedMenu')
const LoginAsAdmin = () => import('@/views/LoginAsAdmin')
const LoginFromToken = () => import('@/views/LoginFromToken')
const Calculator = () => import('@/views/Calculator')
const DietTypes = () => import('@/views/DietTypes')
const SendEmail = () => import('@/views/SendEmail')
const ClientWeeklyShare = () => import('@/views/ClientWeeklyShare')

const Checkout = () => import('@/views/Checkout')

const PageNotFound = () => import('@/views/pages/Page404.vue')
const PageError = () => import('@/views/pages/Page500.vue')

const Weeks = () => import('@/views/nutritionist/Weeks.vue')
const ClientWeeks = () => import('@/views/nutritionist/ClientWeeks.vue')
const WeeklyMenus = () => import('@/views/nutritionist/WeeklyMenus.vue')


Vue.use(Router)

export default new Router({
    // mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: 'calendar',
          name: 'Calendar',
          component: Calendar
        },
        {
          path: 'nutritionist',
          name: 'Nutritionist',
          component: Nutritionist,
          children: [
            {
              path: 'clients',
              name: 'Clients',
              component: Clients,
            },
            {
              path: 'clients/add',
              name: 'AddClient',
              component: AddClient
            },
            {
              path: 'menus',
              name: 'Menus',
              component: Menus
            },
            {
              path: 'menus/:id',
              name: 'SingleMenu',
              component: SingleMenu
            },
            {
              path: 'menus/:id',
              name: 'SingleCreatedMenu',
              component: SingleMenu
            },
            {
              path: 'create-menu',
              name: 'Create Menu',
              component: CreateMenu
            },
            {
              path: 'update-menu/:id',
              name: 'Update Menu',
              component: UpdateMenu
            },
            {
              path: 'create-menu/:id',
              name: 'CreateMenuWithClient',
              component: CreateMenu
            },
            {
              path: 'clients/:id',
              name: 'SingleClient',
              component: SingleClient
            },
            {
                path: 'weeks',
                name: 'Weeks',
                component: Weeks
            },
            {
                path: 'client-weeks',
                name: 'ClientWeeks',
                component: ClientWeeks
            },
            {
                path: 'weeks/menus/:week_id/:client_id',
                name: 'WeeklyMenus',
                component: WeeklyMenus
            },
          ]
        },
        {
          path: 'bmi',
          name: 'Bmi',
          component: Bmi
        },
        {
          path: 'calculator',
          name: 'Calculator',
          component: Calculator
        },
        {
          path: 'diets',
          name: 'DietTypes',
          component: DietTypes
        },
        {
          path: 'specialists',
          name: 'Specialists',
          component: Specialists
        },
        {
            path: 'shop',
            name: 'Shop',
            component: Shop,
        },
        {
            path: 'checkout',
            name: 'Checkout',
            component: Checkout
        },
        {
          path: 'orders',
          name: 'Orders',
          component: Sales
        },
        {
          path: 'send-email',
          name: 'send-email',
          component: SendEmail
        },
        {
          path: 'news',
          name: 'Help',
          component: Help
        },
        {
          path: 'about',
          name: 'About',
          component: About
        },
        {
          path: 'how-to',
          name: 'HowTo',
          component: HowTo
        },
      ]
    },
    {
      path: '/',
      name: 'Auth',
      component: SimpleContainer,
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
      ]
    },
    {
      path: '/log-a-adm/:uid',
      name: 'LoginAsAdmin',
      component: LoginAsAdmin
    },
    {
      path: '/login-go',
      name: 'LoginFromToken',
      component: LoginFromToken
    },
    {
      path: '/share/:uid',
      name: 'SharedMenu',
      component: SharedMenu
    },
    {
      path: '/share/weekly-menus/:uid',
      name: 'ClientWeeklyShare',
      component: ClientWeeklyShare
    },
    {
      path: "*", 
      name: 'PageNotFound',
      component: PageNotFound
    }
  ]
});

